import type { CSSProperties } from 'react'
import { css, styled } from 'styled-components'

import type { DynamicSizeVariables } from '../../theme/generated/theme-variables'

import type { TypographyProps, TypographyVariants } from './Typography.Types'

export const typographyStyles = (variant: TypographyVariants) => {
  switch (variant) {
    case 'Headline/H 10 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 0.625rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 12': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 12 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 14': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 14 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 16': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 16 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 20': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.25rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 20 Bold': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 20 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 1.25rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 24': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 24 Bold': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 24 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 28 Bold': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.75rem;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 32': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 2rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 32 Bold': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 2rem;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 32 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 2rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Headline/H 40 Condensed': {
      return css`
        font-family: 'Graphik XXCond Web', sans-serif;
        font-size: 2.5rem;
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.01em;
        text-transform: uppercase;
      `
    }
    case 'Headline/H 40 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 2.5rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
      `
    }
    case 'Headline/H 48 Condensed': {
      return css`
        font-family: 'Graphik XXCond Web', sans-serif;
        font-size: 3rem;
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.01em;
        text-transform: uppercase;
      `
    }
    case 'Headline/H 48 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 3rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
      `
    }
    case 'Headline/H 56 Condensed': {
      return css`
        font-family: 'Graphik XXCond Web', sans-serif;
        font-size: 3.5rem;
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.01em;
        text-transform: uppercase;
      `
    }
    case 'Headline/H 56 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 3.5rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
      `
    }
    case 'Headline/H 64 Condensed': {
      return css`
        font-family: 'Graphik XXCond Web', sans-serif;
        font-size: 4rem;
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.01em;
        text-transform: uppercase;
      `
    }
    case 'Headline/H 64 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 4rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
      `
    }
    case 'Headline/H 88 Wide': {
      return css`
        font-family: 'Graphik Wide Web', sans-serif;
        font-size: 5.5rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
      `
    }
    case 'Headline/H 96 Condensed': {
      return css`
        font-family: 'Graphik XXCond Web', sans-serif;
        font-size: 6rem;
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.01em;
        text-transform: uppercase;
      `
    }
    case 'Headline/H10': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.625rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Poppins/H1': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H1'] || '2rem'};
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H1'] || '2.25rem'};
        }
      `
    }
    case 'Poppins/H1 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H1'] || '2rem'};
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.03em;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H1'] || '2.25rem'};
        }
      `
    }
    case 'Poppins/H2': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H2'] || '1.75rem'};
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H2'] || '2rem'};
        }
      `
    }
    case 'Poppins/H2 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H2'] || '1.75rem'};
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.03em;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H2'] || '2rem'};
        }
      `
    }
    case 'Poppins/H3': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H3'] || '1.5rem'};
        font-weight: 600;
        line-height: 120%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H3'] || '1.75rem'};
        }
      `
    }
    case 'Poppins/H3 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H3'] || '1.5rem'};
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.03em;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H3'] || '1.75rem'};
        }
      `
    }
    case 'Poppins/H4': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H4'] || '1.25rem'};
        font-weight: 600;
        line-height: 120%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H4'] || '1.5rem'};
        }
      `
    }
    case 'Poppins/H4 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/H4'] || '1.25rem'};
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.03em;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/H4'] || '1.5rem'};
        }
      `
    }
    case 'Poppins/T1': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T1'] || '1.125rem'};
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T1'] || '1.125rem'};
        }
      `
    }
    case 'Poppins/T1 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T1'] || '1.125rem'};
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T1'] || '1.125rem'};
        }
      `
    }
    case 'Poppins/T1 - Semibold': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T1'] || '1.125rem'};
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T1'] || '1.125rem'};
        }
      `
    }
    case 'Poppins/T2': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T2'] || '1rem'};
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T2'] || '1rem'};
        }
      `
    }
    case 'Poppins/T2 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T2'] || '1rem'};
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T2'] || '1rem'};
        }
      `
    }
    case 'Poppins/T2 - Semibold': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T2'] || '1rem'};
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T2'] || '1rem'};
        }
      `
    }
    case 'Poppins/T3': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T3'] || '0.875rem'};
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T3'] || '0.875rem'};
        }
      `
    }
    case 'Poppins/T3 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T3'] || '0.875rem'};
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T3'] || '0.875rem'};
        }
      `
    }
    case 'Poppins/T3 - Semibold': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T3'] || '0.875rem'};
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T3'] || '0.875rem'};
        }
      `
    }
    case 'Poppins/T4': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T4'] || '0.75rem'};
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T4'] || '0.75rem'};
        }
      `
    }
    case 'Poppins/T4 - Medium': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T4'] || '0.75rem'};
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T4'] || '0.75rem'};
        }
      `
    }
    case 'Poppins/T4 - Semibold': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T4'] || '0.75rem'};
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T4'] || '0.75rem'};
        }
      `
    }
    case 'Poppins/T5': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: ${({ theme }) =>
          theme?.dynamicSizes?.mobile['Typography/T5'] || '0.625rem'};
        font-weight: 400;
        line-height: 110%;
        letter-spacing: 0;

        @media (min-width: 768px) {
          font-size: ${({ theme }) =>
            theme?.dynamicSizes?.desktop['Typography/T5'] || '0.625rem'};
        }
      `
    }
    case 'Special/Button 12': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Special/Button 14': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Special/Button 16': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Special/Button 20': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.25rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Special/Button 24': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: 0;
      `
    }
    case 'Special/Label 10': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.625rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
      `
    }
    case 'Special/Label 10 Uppercase': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.625rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      `
    }
    case 'Special/Label 12': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
      `
    }
    case 'Special/Label 12 Uppercase': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      `
    }
    case 'Special/Label 14': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
      `
    }
    case 'Special/Label 14 Uppercase': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      `
    }
    case 'Special/Label 16': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
      `
    }
    case 'Special/Label 16 Uppercase': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      `
    }
    case 'Special/Label 8': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.5rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
      `
    }
    case 'Special/Label 8 Uppercase': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.5rem;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      `
    }
    case 'Special/Link 14': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;

        text-decoration: underline;
      `
    }
    case 'Special/Link 16': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;

        text-decoration: underline;
      `
    }
    case 'Special/Link 20': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.25rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;

        text-decoration: underline;
      `
    }
    case 'Test P ONB Headline/Desktop/H1': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: 2.25rem;
        font-weight: 700;
        line-height: 2.625rem;
        letter-spacing: -0.025rem;
      `
    }
    case 'Test P ONB Headline/Desktop/H2': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: 2rem;
        font-weight: 700;
        line-height: 2.375rem;
        letter-spacing: -0.019rem;
      `
    }
    case 'Test P ONB Headline/Mobile/H1': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: 2rem;
        font-weight: 700;
        line-height: 2.375rem;
        letter-spacing: -0.019rem;
      `
    }
    case 'Test P ONB Headline/Mobile/H2': {
      return css`
        font-family: 'Poppins', sans-serif;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 2rem;
        letter-spacing: -0.013rem;
      `
    }
    case 'Text/Body 10': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.625rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;
      `
    }
    case 'Text/Body 12': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;
      `
    }
    case 'Text/Body 14': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;
      `
    }
    case 'Text/Body 16': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;
      `
    }
    case 'Text/Body 20': {
      return css`
        font-family: 'Graphik LCG Web', sans-serif;
        font-size: 1.25rem;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 0;
      `
    }
    default: {
      throw new Error('Unknown typography variant')
    }
  }
}

export const typographyObjectWithSizes = (
  variant: TypographyVariants,
  sizes: DynamicSizeVariables
): CSSProperties => {
  switch (variant) {
    case 'Headline/H 10 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '0.625rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 12': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 12 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 14': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 14 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 16': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 16 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 20': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 20 Bold': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 20 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 24': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 24 Bold': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 24 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 28 Bold': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.75rem',
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 32': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '2rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 32 Bold': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '2rem',
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 32 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '2rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Headline/H 40 Condensed': {
      return {
        fontFamily: "'Graphik XXCond Web', sans-serif",
        fontSize: '2.5rem',
        fontWeight: 500,
        lineHeight: '90%',
        letterSpacing: '-0.01em',
        textTransform: 'uppercase',
      }
    }
    case 'Headline/H 40 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '2.5rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '-0.02em',
      }
    }
    case 'Headline/H 48 Condensed': {
      return {
        fontFamily: "'Graphik XXCond Web', sans-serif",
        fontSize: '3rem',
        fontWeight: 500,
        lineHeight: '90%',
        letterSpacing: '-0.01em',
        textTransform: 'uppercase',
      }
    }
    case 'Headline/H 48 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '3rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '-0.02em',
      }
    }
    case 'Headline/H 56 Condensed': {
      return {
        fontFamily: "'Graphik XXCond Web', sans-serif",
        fontSize: '3.5rem',
        fontWeight: 500,
        lineHeight: '90%',
        letterSpacing: '-0.01em',
        textTransform: 'uppercase',
      }
    }
    case 'Headline/H 56 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '3.5rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '-0.02em',
      }
    }
    case 'Headline/H 64 Condensed': {
      return {
        fontFamily: "'Graphik XXCond Web', sans-serif",
        fontSize: '4rem',
        fontWeight: 500,
        lineHeight: '90%',
        letterSpacing: '-0.01em',
        textTransform: 'uppercase',
      }
    }
    case 'Headline/H 64 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '4rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '-0.02em',
      }
    }
    case 'Headline/H 88 Wide': {
      return {
        fontFamily: "'Graphik Wide Web', sans-serif",
        fontSize: '5.5rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '-0.02em',
      }
    }
    case 'Headline/H 96 Condensed': {
      return {
        fontFamily: "'Graphik XXCond Web', sans-serif",
        fontSize: '6rem',
        fontWeight: 500,
        lineHeight: '90%',
        letterSpacing: '-0.01em',
        textTransform: 'uppercase',
      }
    }
    case 'Headline/H10': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.625rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/H1': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H1'] ?? '2rem',
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/H1 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H1'] ?? '2rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '-0.03em',
      }
    }
    case 'Poppins/H2': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H2'] ?? '1.75rem',
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/H2 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H2'] ?? '1.75rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '-0.03em',
      }
    }
    case 'Poppins/H3': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H3'] ?? '1.5rem',
        fontWeight: 600,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/H3 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H3'] ?? '1.5rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '-0.03em',
      }
    }
    case 'Poppins/H4': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H4'] ?? '1.25rem',
        fontWeight: 600,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/H4 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/H4'] ?? '1.25rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '-0.03em',
      }
    }
    case 'Poppins/T1': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T1'] ?? '1.125rem',
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T1 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T1'] ?? '1.125rem',
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T1 - Semibold': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T1'] ?? '1.125rem',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T2': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T2'] ?? '1rem',
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T2 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T2'] ?? '1rem',
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T2 - Semibold': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T2'] ?? '1rem',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T3': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T3'] ?? '0.875rem',
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T3 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T3'] ?? '0.875rem',
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T3 - Semibold': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T3'] ?? '0.875rem',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T4': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T4'] ?? '0.75rem',
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T4 - Medium': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T4'] ?? '0.75rem',
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T4 - Semibold': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T4'] ?? '0.75rem',
        fontWeight: 600,
        lineHeight: '140%',
        letterSpacing: '0',
      }
    }
    case 'Poppins/T5': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: sizes['Typography/T5'] ?? '0.625rem',
        fontWeight: 400,
        lineHeight: '110%',
        letterSpacing: '0',
      }
    }
    case 'Special/Button 12': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Special/Button 14': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Special/Button 16': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Special/Button 20': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Special/Button 24': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: '120%',
        letterSpacing: '0',
      }
    }
    case 'Special/Label 10': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.625rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
      }
    }
    case 'Special/Label 10 Uppercase': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.625rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      }
    }
    case 'Special/Label 12': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
      }
    }
    case 'Special/Label 12 Uppercase': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      }
    }
    case 'Special/Label 14': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
      }
    }
    case 'Special/Label 14 Uppercase': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      }
    }
    case 'Special/Label 16': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
      }
    }
    case 'Special/Label 16 Uppercase': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      }
    }
    case 'Special/Label 8': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.5rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
      }
    }
    case 'Special/Label 8 Uppercase': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.5rem',
        fontWeight: 500,
        lineHeight: '110%',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      }
    }
    case 'Special/Link 14': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',

        textDecoration: 'underline',
      }
    }
    case 'Special/Link 16': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',

        textDecoration: 'underline',
      }
    }
    case 'Special/Link 20': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',

        textDecoration: 'underline',
      }
    }
    case 'Test P ONB Headline/Desktop/H1': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '2.25rem',
        fontWeight: 700,
        lineHeight: '2.625rem',
        letterSpacing: '-0.025rem',
      }
    }
    case 'Test P ONB Headline/Desktop/H2': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '2rem',
        fontWeight: 700,
        lineHeight: '2.375rem',
        letterSpacing: '-0.019rem',
      }
    }
    case 'Test P ONB Headline/Mobile/H1': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '2rem',
        fontWeight: 700,
        lineHeight: '2.375rem',
        letterSpacing: '-0.019rem',
      }
    }
    case 'Test P ONB Headline/Mobile/H2': {
      return {
        fontFamily: "'Poppins', sans-serif",
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: '2rem',
        letterSpacing: '-0.013rem',
      }
    }
    case 'Text/Body 10': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.625rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',
      }
    }
    case 'Text/Body 12': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',
      }
    }
    case 'Text/Body 14': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',
      }
    }
    case 'Text/Body 16': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',
      }
    }
    case 'Text/Body 20': {
      return {
        fontFamily: "'Graphik LCG Web', sans-serif",
        fontSize: '1.25rem',
        fontWeight: 400,
        lineHeight: '130%',
        letterSpacing: '0',
      }
    }
    default: {
      throw new Error('Unknown typography variant')
    }
  }
}

export const Typography = styled.p<TypographyProps>`
  color: ${({ $color }) => $color || 'inherit'};
  margin: 0;
  padding: 0;
  text-align: ${({ $textAlign }) => $textAlign || 'inherit'};
  ${({ $variant }) => typographyStyles($variant)}
`
